/* eslint-disable react/no-array-index-key */
import {
  Hidden,

  //   IconButton,
  Stack,
  Typography
} from '@mui/material';

import React from 'react';
import i18n from '@utils/i18n';

import RowLayout from '@components/RowLayout';
import env from '@constants/env';

const SkillImage = `${env.s3BaseUrl}/landing-page/homepage/skill.png`;

const Skill = () => {
  const t = i18n.getFixedT(null, null, 'pages.flagshop.skill');

  return (
    <RowLayout
      sx={{
        height: 'auto',
        backgroundColor: '#FFFFFF',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { md: '434px', xs: '254px' },
        py: { md: '150px', xs: '40px' },
        position: 'relative'
      }}
    >
      <Hidden mdDown>
        <Stack
          sx={{
            width: { md: '75%', lg: '100%' },
            height: '100%',
            maxWidth: '1920px',
            px: { lg: '320px' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10
          }}
        >
          <Stack
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 50,
              background: `url(${SkillImage}) lightgray 50% / cover no-repeat`
            }}
          />

          <Typography
            fontWeight={700}
            fontFamily="Pretendard"
            sx={{
              color: '#000',
              zIndex: 51,
              fontSize: 48,
              letterSpacing: '-2.4px',
              lineHeight: '100%',
              whiteSpace: 'nowrap'
            }}
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="600"
            data-aos-once="true"
            data-aos-duration="600"
          >
            {t('title')}
          </Typography>
        </Stack>
      </Hidden>

      <Hidden mdUp>
        <Stack
          sx={{
            width: '100%',
            height: '100%',

            px: '20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Stack
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 50,
              background: `url(${SkillImage}) lightgray 50% / cover no-repeat`
            }}
          />

          <Typography
            fontWeight={700}
            fontFamily="Pretendard"
            sx={{
              color: '#000',
              zIndex: 51,
              fontSize: { xs: 30, sm: 40 },
              textAlign: 'center',
              letterSpacing: { xs: '-1.5px', sm: '-2.5px' },
              lineHeight: '130%'
            }}
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="600"
            data-aos-once="true"
            data-aos-duration="600"
          >
            {t('title')}
          </Typography>
        </Stack>
      </Hidden>
    </RowLayout>
  );
};

export default Skill;
